import { styled as t, css as e } from "styled-components";
import { ZIndex as n, MODAL_OVERLAY as d, HEADER_HEIGHT as p, MediaQuery as s } from "../../styles/variables.js";
const a = t.div`
  display: ${(i) => i.open ? "block" : "none"};
  top: 66px;
  position: absolute;
  z-index: ${n.HEADER_CONTAINER};
`, o = e`
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  width: 100vw;
  height: 100vh;
  min-height: 100%;
  min-width: 100%;
  background: ${d};
  z-index: -1;
`, m = t.div`
  top: ${p}px;
  ${o}

  @media ${s.SCREEN_SM} {
    top: 0;
    ${o}
  }
`;
export {
  a as Content,
  m as DropdownBackground
};
